import { Provider } from '@angular/core';
import { SignaturesHttpService } from './abstract';
import { SignaturesHttpServiceImpl } from './signatures.service';

export const SignaturesHttpProvider: Provider = {
	provide: SignaturesHttpService,
	useClass: SignaturesHttpServiceImpl,
};
